import { put, takeLatest } from 'redux-saga/effects';
import instance from 'src/sagas/set';
import { ReviewActionCreators } from 'src/store/reducers/feedback/action-creators';
import { ReviewActionEnum } from 'src/store/reducers/feedback/types';

function* fetchDeleteReview({ id }: ReturnType<typeof ReviewActionCreators.deleteReview>) {
  try {
    const { status }: Response = yield instance.delete(`feedback/${id}`);
    yield put(ReviewActionCreators.resultDeleteReview(status));
  } catch (e) {
    console.log(e);
  }
}
export function* actionWatcherDeleteReview() {
  yield takeLatest(ReviewActionEnum.REQUEST_DELETE_REVIEW, fetchDeleteReview);
}
